// extracted by mini-css-extract-plugin
export default {"number":"workflow_number__RpFnk"};